import React from 'react'

import MissingDatasetsAndCustomConversionWarningMessage from './MissingDatasetsAndCustomConversionWarningMessage'
import MissingClientAppWarningMessage from './MissingClientAppWarningMessage'

import { useShowMissingClientAppsWarning, useShowMissingDatasetAndCustomConversionWarning } from '../hooks'

const MissingDataWarnings = ({ values }) => {
  const showMissingDatasetAndCustomConversionWarning = useShowMissingDatasetAndCustomConversionWarning(values)
  const showMissingClientAppsWarning = useShowMissingClientAppsWarning(values)

  return (
    <>
      {showMissingDatasetAndCustomConversionWarning && <MissingDatasetsAndCustomConversionWarningMessage />}
      {showMissingClientAppsWarning && <MissingClientAppWarningMessage />}
    </>
  )
}

export default MissingDataWarnings
